import { SvgIcon } from '@admin/shared/components/icons/svg-icon';
import type { SvgIconComponentProps } from '@admin/shared/components/icons/svg-icon';

/**
 * Attention Icon.
 *
 * @param {SvgIconComponentProps} props - svg component props.
 *
 * @returns {JSX.Element}
 */
export const AttentionIcon = (props: SvgIconComponentProps): JSX.Element => {
  return (
    <SvgIcon name="UserlikeAttentionIcon" viewBox="0 0 64 64" {...props}>
      <circle
        cx="32"
        cy="32"
        r="27"
        transform="rotate(-180 32 32)"
        stroke="#00101F"
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M32 33V19"
        stroke="#0D8CFF"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.5858 44.4142C29.8047 43.6332 29.8047 42.3668 30.5858 41.5858C31.3668 40.8047 32.6332 40.8047 33.4142 41.5858C34.1953 42.3668 34.1953 43.6332 33.4142 44.4142C32.6332 45.1953 31.3668 45.1953 30.5858 44.4142Z"
        fill="#0D8CFF"
      />
    </SvgIcon>
  );
};
